import React from 'react';
import { useLingui } from '@lingui/react/macro';
import { EmptyPlayersMessageContainer } from './empty-players-message.styles';

export const EmptyPlayersMessage = () => {
  const { t } = useLingui();

  return <EmptyPlayersMessageContainer>{t`Нет игроков вступивших в команду`}</EmptyPlayersMessageContainer>;
};
